import React from 'react';
import {Language} from '../../assets/ts/customTypes';
import {
    LanguagePickerContainer,
    LanguagePickerFlag,
    LanguagePickerSelect
} from '../../assets/ts/layout/header';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import { languages } from '../../assets/languages/languages';

export function LanguagePicker({
    language,
    onChange
}: { language: Language; onChange: (language: Language) => void }) {
    const { trackEvent } = useMatomo();
    return (
        <LanguagePickerContainer>
            <LanguagePickerFlag>
                <img src={language.flagUrl} alt=''/>
            </LanguagePickerFlag>
            <LanguagePickerSelect onChange={handleSelection} value={language.id}>
                {languages.map((language) => <option key={language.id} value={language.id}>{language.languageName}</option>)}
            </LanguagePickerSelect>
        </LanguagePickerContainer>
    );

    function handleSelection(event: React.ChangeEvent<HTMLSelectElement>) {
        const language = languages.find((innerLanguage) => innerLanguage.id === event.target.value);
        if (!language) {
            console.error(`Invalid language ${event.target.value}`);
            return;
        }

        onChange(language);

        trackEvent({
            category: 'language switch',
            action: 'click-event',
            name: event.target.value,
        });
    }
}
